import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";

/**
 * @description 江苏文交所二期
 * @return {/culturalExchange_gold/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  // const [shiwuThing, setShiwuThing] = useState({})
  const { nftNo } = qs.parse(window.location.search);

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus();
        const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        setHasPermission(accessRes.data?.isPermission)
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  const buyHandle = () => {
    if(!hasPermission){
      return;
    }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
  }
  const toMyGuards = () => {
    let uri = '/culturalExchange/thirteenGuards'
    if(uri){
      if (window.JsBridge.hasWebViewBridge()) {
        window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` })
      } else {
        navigate(uri);
      }
    }
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }
  const toRecord = () => {
    const uri = `/culturalExchange_gold/collectionRecord`
    if(uri){
      navigate(uri);
    }
  }
  //立即领取 ，跳转G-member订单页面
  const handleToOrder = async (type) => {
    //type 1 优先购 2 全套漫画
    // Toast.show(data?.canNum);
    if(type === 2 && !data?.canNum) {
      Toast.show('请先购买黄金甲无聊猿')
      return
    }
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural_gold',
        activityCode: Service.activityCode,
        req: data?.defaultGoods?.id,
        name: data?.defaultGoods?.goodsName,
        imgUrl: data?.defaultGoods?.imgUrl,
        productId:data?.defaultGoods?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: data?.defaultGoods?.goodsId,
        prizeImgUrl: data?.defaultGoods?.imgUrl,
        prizeName: data?.defaultGoods?.goodsName,
        nftNo: nftNo,
        remark: type,
        needShowCount:type===1?data?.badgeNum:data?.canNum,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
      onDidFocus();
  }
  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.buyBtn} style={{ filter: hasPermission ? '' : 'grayscale(1)'}} onClick={buyHandle} disabled={!hasPermission}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {data?.priNum && <div className={Styles.textCount}>优先购最多可购买{data?.priNum || 0}个</div>}

      <div className={Styles.centerCard}>
        <div className={Styles.centerCardBox1}>
          <div className={Styles.title}>持有欧皇徽章用户可领</div>
          <div className={Styles.context}>
            <div className={Styles.lefttem}>
                <div className={Styles.leftItem1}>
                  2025.08.13 15:00持仓用户
                </div>
                <div className={Styles.leftItem2} style={{ filter: data?.badgeFlag ? '' : 'grayscale(1)'}}>
                  <button className={Styles.leftItem2Btn} onClick={()=>handleToOrder(1)} disabled={!data?.badgeFlag}>立即领取</button>
                </div>
            </div>
            <div className={Styles.rightItem}>
                <div className={Styles.rightItem1}></div>
                <div className={Styles.rightItem2}>0.1克小金片</div>
            </div>
          </div>
        </div>
        <div className={Styles.centerCardBox2}>
          <div className={Styles.titlebox}>
            <div className={Styles.titleboxLeft}>
              全套漫画持有用户福利！
            </div>
            
          </div>
          <div className={Styles.context}>
            <div className={Styles.lefttem}>
                <div className={Styles.leftItem1}>
                2025.08.13 15:00验仓
                </div>
                <div className={Styles.leftItem2}>
                全套漫画持有用户，每购买 1 个黄金甲无聊猿藏品，多赠送 1 份0.1 克小金片。最多领取数量为持有全套漫画的套数
                </div>
                <div className={Styles.leftItem3}>
                  <span className={Styles.leftItem3Title1}>可领取 </span>
                  <span className={Styles.leftItem3Title2}>{data?.canNum || 0}</span>
                  <span className={Styles.leftItem3Title1}>个</span>
                  <span className={Styles.leftItem3Title3}>（最多领取 </span>
                  <span className={Styles.leftItem3Title2}>{data?.maxNum || 0}</span>
                  <span className={Styles.leftItem3Title3}>个，已领取 </span>
                  <span className={Styles.leftItem3Title3}>{data?.recNum || 0}</span>
                  <span className={Styles.leftItem3Title3}> 个）</span>
                </div>
                <div className={Styles.leftItem4} onClick={()=>handleToOrder(2)}>
                  <button className={Styles.leftItem2Btn}>立即领取</button>
                </div>
            </div>
            <div className={Styles.rightItem}>
                <div className={Styles.rightItem1}></div>
                <div className={Styles.rightItem2}>0.1克小金片</div>
            </div>
          </div>
        </div>

        <div className={Styles.centerCardBox4} onClick={toRecord}>
              领取记录{">"}
          </div>

        <div className={Styles.centerCardBox3}>
          <div className={Styles.title}>藏品权益</div>
          <div className={Styles.context}>
          <div className={Styles.rareItemsCard}>
              <div className={Styles.title}>稀有款</div>
              <div className={Styles.itemsContainer}>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_gold/coupon@2x.png')} alt="优惠券" />
                    </div>
                    <div className={Styles.itemText}>优惠券</div>
                  </div>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_gold/goldcard@2x.png')} alt="小金片" />
                    </div>
                    <div className={Styles.itemText}>1克小金片</div>
                  </div>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_gold/land.png')} alt="A级土地" />
                    </div>
                    <div className={Styles.itemText}>A级土地</div>
                  </div>
                </div>
              </div>
            <div className={Styles.rareItemsCard}>
              <div className={Styles.title}>普通款</div>
              <div className={Styles.itemsContainer}>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_gold/coupon@2x.png')} alt="优惠券" />
                    </div>
                    <div className={Styles.itemText}>优惠券</div>
                  </div>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_gold/goldcard@2x.png')} alt="小金片" />
                    </div>
                    <div className={Styles.itemText}>0.1克小金片</div>
                  </div>
                  <div className={Styles.item}>
                    <div className={Styles.imageWrapper}>
                      <img src={require('@/assets/img/culturalExchange_gold/Bland.png')} alt="A级土地" />
                    </div>
                    <div className={Styles.itemText}>B级土地</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={Styles.footerBox}>
            <div className={Styles.footer}></div>
          </div>
      </div>

      
    </div>
  )
}
export default Home
